<template>
  <div class="project-progress-trend-chart" v-loading="loading">
    <div class="echarts-box">
      <Projectprogress :rangeTime="rangeTime" :projectId="projectId" isDetail />
    </div>

    <div class="table-content">
      <ul class="filter-wrap">
        <li
          v-for="item of filterList"
          :key="item.value"
          :class="{'active': item.active}"
          @click="handleChos(item)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <el-table
      :data="tableList"
      border
      :height="height"
      row-key="id"
      @row-click="handleRowClick"
    >
    <el-table-column prop="create_time" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time.replace(/-/g,'/') }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="task_name" label="任务名称" width="302" show-overflow-tooltip>
        <!-- <template slot-scope="scope">
          <toolTip
            class="task-name"
            :title="scope.row.task_name"
            :maxWidth="'238px'"
          >
            <span>{{ scope.row.task_name }}</span>
          </toolTip>
        </template> -->
      </el-table-column>

      <el-table-column prop="task_stage_type" label="任务状态">
        <!-- <template slot-scope="scope">
          <span>{{ scope.row.task_stage === '已归档' ? scope.row.executor_user.realname : '' }}</span>
        </template> -->
      </el-table-column>

      <el-table-column prop="executor_user" label="执行人">
        <template slot-scope="scope">
          <span>{{ scope.row.executor_user ? scope.row.executor_user.realname : '' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="task_completed_time" label="完成时间">
        <template slot-scope="scope">
          <span>{{ scope.row.task_completed_time ? scope.row.task_completed_time.replace(/-/g,'/') : '' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="task_archived_time" label="归档时间">
        <template slot-scope="scope">
          <span>{{ scope.row.task_archived_time ? scope.row.task_archived_time.replace(/-/g,'/') : '' }}</span>
        </template>
      </el-table-column>

      <template slot="append">
        <div v-if="isScrollLoading" class="loading-text">数据加载中...</div>
      </template>

    </el-table>

    <nothing v-if="!tableList.length"></nothing>
  </div>
</template>

<script>
import Projectprogress from '../../projectprogress'
import { mapMutations } from "vuex"
import api from '@/services/api/statistics/statistics'

export default {
  components: {
    Projectprogress
  },
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    rangeTime: {
      type: [Array, Object],
      default: []
    },
  },
  data() {
    const _ts = this
    return {
      height: null,
      loading: false,
      isScrollLoading: false,
      finishLoad: false,
      tableList: [],
      filterList: [
        {
          label: '任务总数详情表',
          value: 6,
          active: true
        },
        {
          label: '未完成详情表',
          value: 2,
          active: false
        },
        {
          label: '已完成详情表',
          value: 3,
          active: false
        },
        {
          label: '待认领详情表',
          value: 1,
          active: false
        },
        {
          label: '已归档详情表',
          value: 4,
          active: false
        }
      ],
      param: {
        per_page: 20,
        page: 1,
        project_id: _ts.projectId,
        task_stage_type: 6
      }
    }
  },
  watch: {
    // rangeTime: {
    //   handler() {
    //     this.getTableData()
    //   },
    //   deep: true
    // },
    // projectId(val) {
    //   if (val) {
    //     this.init()
    //     this.getTableData()
    //   }
    // }
  },
  mounted() {
    this.loading = true
    this.getTableData()

    // 获取当前窗口下表格可移动的最高高度 (用窗口的高度减去其他各个元素的高度)
    this.height = window.innerHeight - 78 - 344 - 47

    // 监听表格的滚动条，实现下拉加载功能
    const _ele = document.querySelector('.el-table__body-wrapper')
    _ele.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    const _ele = document.querySelector('.el-table__body-wrapper')
    _ele.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations("task/task", ["CHANGE_TASK"]),
    getTableData() {
      setTimeout(async () => {
        const res = await api.getProjectProgressOverviewTable(this.param)
        if (res) {
          this.loading = false
          this.isScrollLoading = false
          this.tableList.push(...res.data)
          if (res.data.length < this.param.per_page) {
            this.finishLoad = true
          }
        }
      }, 500)

    },
    handleScroll() {
      const _ele = document.querySelector('.el-table__body-wrapper') //获取滚动可视区域的元素
      const _ele2 = _ele.querySelector('.el-table__body') // 获取滚动区域的元素
      const scrollTop = _ele.scrollTop // 获取滚动条距离顶部的距离
      const clientHeight = _ele.clientHeight // 获取可视区域的高度
      const scrollHeight = _ele2.scrollHeight // 获取滚动区域的总高度

      // console.log(scrollTop, clientHeight, scrollHeight, 111)
      if (scrollTop + clientHeight >= scrollHeight && !this.isScrollLoading) {
        // 已滚动到底部并且不处于加载状态
        this.load()
      }
    },
    load() {
      if (this.finishLoad) return

      this.param.page += 1
      this.isScrollLoading = true
      this.getTableData()
    },
    handleChos(item) {
      if (item.active) return
      this.loading = true
      const _list = this.filterList
      for(let i = 0, len = _list.length; i < len; i++) {
        _list[i].active = false
      }
      item.active = true
      this.finishLoad = false
      this.param.task_stage_type = item.value
      this.param.page = 1
      this.tableList = []
      this.getTableData()
    },
    // 点击行，打开该任务详情
    handleRowClick(row) {
      const task_id = row.id
      const task_list_id = row.task_list_id
      this.CHANGE_TASK({ visible: true, task_id, task_list_id });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.project-progress-trend-chart {
  .table-content {
    .filter-wrap {
      width: 778px;
      margin: 9px auto 16px;
      display: flex;
      justify-content: space-between;
      li {
        font-size: 16px;
        line-height: 22px;
        @include fontColorOpacity(.6);
        cursor: pointer;
        &:hover,
        &:active,
        &.active {
          @include fontColorOpacity(1);
        }
      }
    }
  }

  .loading-text {
    text-align: center;
    font-size: 14px;
    line-height: 32px;
    @include fontColorOpacity(.6);
  }

  .nothing-box {
    top: 80%;
  }

  /deep/ .el-table--border th:first-child .cell,
  /deep/ .el-table--border td:first-child .cell {
    padding-left: 80px;
  }

  /deep/ .el-table--border th .cell,
  /deep/ .el-table--border td .cell {
    padding-left: 24px;
  }

  /deep/ .el-table__empty-text {
    display: none;
  }
}
</style>
